'use client';
import { Close } from '@mui/icons-material';
import { ChipProps } from '@mui/material';
import { KernChip } from './style';
import { useTheme } from '../../../hooks';

interface Props extends ChipProps {
    backgroundColor?: string;
    fontColor?: string;
}

const DigitalHubChip = (props: Props) => {
    const { colors } = useTheme();
    return (
        <KernChip
            aria-label={'Chip Button'}
            deleteIcon={<Close style={{ color: colors.onSurfaceVariant, height: 18 }} />}
            {...props}
        />
    );
};

export { DigitalHubChip };
